import './scheduled-task-queue.component.scss'
import {QueuedTask} from "../../model/QueuedTask";
import {QueuedTaskServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {QueuedTaskService} from "../../../scheduling_service/service/QueuedTaskService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {IScope, ITimeoutService} from "angular";
import {IMessage} from "@stomp/stompjs";
import {
    ScheduledTaskExecutionLogDialog
} from "../scheduled_task_execution_log/scheduled-task-execution-log.dialog.component";

interface ScheduledTaskQueueScope extends IScope {
    tasksQueue: [QueuedTask];
}


export class ScheduledTaskQueueComponent {

    static instance = {
        template: require('./scheduled-task-queue.component.html'),
        controller: [
            '$scope',
            '$timeout',
            '$mdDialog',
            ToastNotificationServiceName,
            QueuedTaskServiceName,
            ScheduledTaskQueueComponent
        ],
        bindings: {
            tasksQueue: '='
        }
    };

    private tasksQueue: [QueuedTask];

    constructor(private $scope: ScheduledTaskQueueScope,
                private $timeout: ITimeoutService,
                private $mdDialog: angular.material.IDialogService,
                private toastNotificationService: ToastNotificationService,
                private queuedTaskService: QueuedTaskService) {
    }

    $onInit() {
        this.$scope.tasksQueue = this.tasksQueue;
        this.queuedTaskService.startQueuedTasksSession(this.handleTaskUpdate);
    }

    $onDestroy() {
        this.queuedTaskService.stopQueuedTasksSession();
    }

    showExecutionLogs = () => {
        this.$mdDialog.show(ScheduledTaskExecutionLogDialog.instance);
    };

    private handleTaskUpdate = (message: IMessage) => {
        let update = <QueuedTask>JSON.parse(message.body);
        this.addToScope(update);
        this.refreshScope();
    };

    private addToScope(update: QueuedTask) {
        let index = this.getIndex(update);
        console.log(`Recieved task ${update.tasksName} ${update.executionId} update: status is ${update.status}; task index: ${index}`);
        if (index === -1) {
            this.$scope.tasksQueue.push(update)
        } else {
            this.$scope.tasksQueue[index] = update;
        }
    }

    private getIndex(update: QueuedTask) {
        return this.$scope.tasksQueue.findIndex((t) => t.executionId === update.executionId);
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let changeObj = onChangesObj['tasksQueue'];
        if (changeObj && !changeObj.isFirstChange()) {
            this.$scope.tasksQueue = changeObj.currentValue;
            this.refreshScope();
        }
    }

    private refreshScope() {
        this.$timeout(() => this.$scope.$apply());
    }
}